import React from 'react'
import {t} from '../../lib/localize'

export default function CloseButton ({onClick}) {
  return (
      <a className={`close-button`} onClick={onClick} >{t('button.close')}</a>
  )
}
